import { withInstall } from '../../utils/install';
import Tooltip from './index.vue';

export const IvueTooltip = withInstall(Tooltip);
export default IvueTooltip;

export * from './index.vue';
